import * as React from "react";
import { LoanHistoryView } from "@tlc/ls2pac/app/views/myAccountViews/accountActivitySubViews/LoanHistoryView";
import { useAccount } from "../../Account";

export const BorrowerHistoryView: React.FC = () => {
  const { accountSummary, user, patron } = useAccount();
  const containerId = "borrowerHistoryContainer";

  React.useEffect(() => {
    const view = new LoanHistoryView();
    view.load(
      { accountSummary, patron },
      user,
      document.getElementById(containerId),
      "loanHistory"
    );
    return () => {
      view?.cleanup();
    };
  }, [accountSummary, user, patron]);

  return <div id={containerId}></div>;
};
